export default [{
  price: 60,
  month: 1,
  hidden_info: true
}, {
  price: 150,
  month: 3,
  ya: 300
}]
